"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalSize = exports.endpoint = exports["default"] = void 0;
var _default = {};
exports["default"] = _default;
var endpoint = '/DictionaryManagement/Definition/DictionaryEntryForTerm';
exports.endpoint = endpoint;
var modalSize = {
  "default": {
    width: 600,
    height: 400
  },
  video: {
    width: 1000,
    height: 410
  }
};
exports.modalSize = modalSize;